import React from 'react';
import Overlay from '../../partials/white_overlay';

const Duration = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Game Duration</h2>
                <p>The game shall consist of two 12-minute halves separated by a two minute halftime period OR the first team to reach 12 goals, whichever comes first. Games tied after regulation play shall end in a tie except in playoffs. A team, at the discretion of the referee and the tournament director, will be forfeited at game time if they are not present. Teams are responsible for waiting until their seed for playoffs has been determined. There are no timeouts in 3v3 soccer. </p>
            </div>
        </div>
    );
}

export default Duration;



// WEBPACK FOOTER //
// ./src/components/rules/partials/duration.js